class PermissionGroup {
    _item;

    constructor(item) {
        this._item = item;
    }

    get raw() {
        return this._item;
    }
}

export default PermissionGroup;